const View = require("presto-ui").baseView;

class Home extends View {

	constructor(props, children, state) {
		super(props, children, state);
		this.shouldCacheScreen = false;

		this.setIds(['Content']);

		this.style_Register = {
			onClick: this.onClickRegister.bind(this)
		}

		this.style_Forum = {
			onClick: this.onClickForum.bind(this)
		}

		this.style_Group = {
			onClick: this.onClickLetsStart.bind(this)
		}

		this.style_Know_how = {
			onClick: this.onClickKnowHow.bind(this)
		}

		this.style_Link = {
			onClick: this.onClickLetsStart.bind(this)
		}
	}

	onClickLetsStart(){
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobileSFP"});
		else
			window.__duiShowScreen(null,{screen:"SFP"});
	}

	onClickRegister() {
		window.open("https://form.jotform.co/73251234628858",'_blank');
	}

	onClickForum() {
		window.open("https://muut.com/purescript-presto",'_blank');
	}

	onClickKnowHow() {
		window.open("https://www.juspay.in",'_blank');
	}

}

module.exports = Home;



// WEBPACK FOOTER //
// ./controller/pages/Main/Home.js